/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ScheduleAroundTodayResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWorkingScheduleAroundToday: build.query<ScheduleAroundTodayResponse, void>({
      query: () => ({ method: 'GET', url: `/v1/master/schedule/around-today` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getWorkingScheduleAroundTodayApi };
export const { useGetWorkingScheduleAroundTodayQuery, useLazyGetWorkingScheduleAroundTodayQuery } = injectedRtkApi;
